

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import googlePlay from '../../ImageAssets/googleplay.png';
import appStore from '../../ImageAssets/appstore.png';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import ValidateForm from '../../Utils/formValidation';
import { setForgetPasswordDetails, setLoginPage } from '../../General/Actions';
import Swal from 'sweetalert2';
import SignUpComponent from './SignUpComponent';
import { FaArrowLeft } from 'react-icons/fa';
import LoadingAnimation from '../../Utils/loadingAnimation.js';

class changePasswordComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }


    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }


    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }
    arrowIconClicked() {
        window.location.reload();
    }


    changePasswordSubmit() {
        if (ValidateForm.inputFieldMandatoryCheck("forgetPasswordChangePasswordContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("forgetPasswordChangePasswordContainer", this.props.locales, false)) {
                if (this.state.newPassword === this.state.confirmPassword) {
                    this.props.setForgetPasswordDetails("password", this.state.newPassword);
                    setTimeout(() => {
                        var dataToSend = {
                            username: this.props.forgetPasswordDetails.username,
                            password: this.props.forgetPasswordDetails.password
                        }
                        console.log("dataToSend =>> ", dataToSend);
                        this.setState({ isLoading: true })
                        Network.executeAxios("forgetPasswordSetPassword", "POST", dataToSend, (setPasswordResponse) => {
                            console.log("setPasswordResponse =>> ", setPasswordResponse);
                            if (setPasswordResponse.STATUS === "SUCCESS") {
                                Swal.fire(this.props.locales.changePasswordSuccessSwal, "", "");
                                window.location.reload();
                            } else if (setPasswordResponse.STATUS === "FAILED") {
                                this.setState({ isLoading: false })
                                Swal.fire(this.props.locales.changePasswordFailedSwal, "", "");
                            }else if (setPasswordResponse.STATUS === "DUPLICATE_PASSWORD") {
                                this.setState({ isLoading: false })
                                Swal.fire(this.props.locales.changePasswordFailedDuplicateSwal, "", "");
                            }
                        });
                    }, 100);
                } else {
                    Swal.fire(this.props.locales.changePasswordMatchSwal, "", "");
                }

            }
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetPasswordSetPasswordOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetPasswordSetPasswordOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.changePasswordPartComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    changePasswordPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                        <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.arrowIconClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                    </div>
                </div>
                <div className="col-md-12 row py-5 m-0 my-5 d-none d-sm-block">

                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-sm-5 pl-2 pt-3 mt-3" id="forgetPasswordChangePasswordContainer">
                        <div className="col-md-12 pb-3" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.changePasswordSetYourPswTxt}</div>
                        <div className="form-group col-md-12 pb-3">
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.changePasswordEnterPswTxt}</label>
                            <Input type="password" name="newPassword" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3"
                                placeholder={this.props.locales.changePasswordNewPswPlc} onChange={(event) => this.inputValueChange("newPassword", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.newPassword, this.props.locales.changePasswordNewPswPlc)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.changePasswordConfirmPswTxt}</label>
                            <Input type="password" name="confirmPassword" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3"
                                placeholder={this.props.locales.changePasswordComfirmPswPlc} onChange={(event) => this.inputValueChange("confirmPassword", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.confirmPassword, this.props.locales.changePasswordComfirmPswPlc)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12 pt-2">
                            {this.props.locales.SettingsCompCharecterToolTip}
                        </div>
                        <div className="col-md-12 pt-4">
                            <Button className="loginPageLoginButton" onClick={() => { this.changePasswordSubmit() }}>
                                {this.props.locales.changePasswordDoneBtn}
                            </Button>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    loginPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 p-0 row m-0 pt-5 pb-5" style={{ backgroundColor: '#000000', height: 'inherit', flex: 1 }}>
                <div className="col-md-1"></div>
                <div className="col-md-9 pl-5 pr-4 row pt-5 mt-5" style={{ flex: 1, alignItems: "center", justifyContent: "center", height: 'inherit' }}>
                    <div className="col-md-12 row" >
                        <div className="mb-1 col-md-12" style={{ fontSize: 35, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.changePasswordNwCanDownloadTxt}</div>
                        <div className=" col-md-12 pt-5 d-flex p-0">
                            <div className="col-md-6 p-0 text-center"><img alt="" src={googlePlay} width="180" /></div>
                            <div className="col-md-6 p-0 text-center"><img alt="" src={appStore} width="180" /></div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        forgetPasswordDetails: state.forgetPasswordDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        }
    }
}

const changePasswordComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(changePasswordComponent)


export default changePasswordComponentContainer;